import { SET_NAV_STATE, HIDE_SNACKBAR, SHOW_SNACKBAR, SHOW_SPINNER, HIDE_SPINNER, SHOW_CONTROLS, HIDE_CONTROLS, WARNING_TOAST  } from '../actionTypes';

// initial state
export const initialState = {};

export default function uiReducer(state = initialState, {type, ...action}) {
  switch (type) {
    case SET_NAV_STATE :
      return {...state, navState: action.navState};

    case SHOW_SNACKBAR :
    case HIDE_SNACKBAR :
      return {...state, showSnackBar: action.showSnackBar, snackBarText: action.snackBarText, hideSnackBarAction: action.hideSnackBarAction};

    case SHOW_SPINNER :
    case HIDE_SPINNER :
      return {...state, showSpinner: action.showSpinner};

    case SHOW_CONTROLS :
    case HIDE_CONTROLS :
      return {...state, hideControls: action.hideControls};

    case WARNING_TOAST :
      return {...state, toast: action};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./shared/redux/reducers/ui.js